import { render, staticRenderFns } from "./PageManualVentilation.vue?vue&type=template&id=52429aa0&scoped=true&"
import script from "./PageManualVentilation.vue?vue&type=script&lang=js&"
export * from "./PageManualVentilation.vue?vue&type=script&lang=js&"
import style0 from "./PageManualVentilation.vue?vue&type=style&index=0&id=52429aa0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52429aa0",
  null
  
)

export default component.exports